module.exports = __webpack_public_path__ + "static/media/sis.f0d78fa4.svg";